import {Component, OnDestroy, OnInit} from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {Router} from '@angular/router';
import {AuthService} from '../../../../services/auth.service';
import {Subscription} from 'rxjs';
import {DatePipe} from '@angular/common';

@Component({
    selector: 'app-normal-sign-up',
    templateUrl: './normal-sign-up.component.html',
    styleUrls: ['./normal-sign-up.component.scss'],
    standalone: false
})
export class NormalSignUpComponent implements OnInit, OnDestroy {

  form: UntypedFormGroup;
  subscription: Subscription = new Subscription();
  minDate = new Date();
  constructor(
    private fb: UntypedFormBuilder,
    private route: Router,
    private auth: AuthService
  ) {
    if (this.auth.alreadyLoggedIn()) {
      this.route.navigate(['', 'dashboard']);
    }
  }

  ngOnInit(): void {

    this.form = this.fb.group({
      // nationalId: [null, [
      //   // Validators.required,
      //   Validators.minLength(20),
      //   Validators.maxLength(20),
      //   Validators.pattern('^[0-9]*$'),
      //   Validators.pattern(/^([0-9_-]){20}$/)
      // ]],
      firstName: [null, Validators.required],
      middleName: [null],
      lastName: [null, Validators.required],
      gender: [null, Validators.required],
      dateOfBirth: [null, Validators.required],
      email: [null, [Validators.required, Validators.email]],
    });

    const today = new Date();
    this.minDate.setFullYear(today.getFullYear() - 18);

  }

  signUpSubmission(formData) {
    // console.log(formData);
    formData.dateOfBirth = new DatePipe('en-Gb').transform(formData.dateOfBirth, 'yyyy-MM-dd');

    this.auth.register(formData);
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
